import HttpService from '../HttpService'

const _http = new HttpService()
export default {
  cancel: (payload) => {
    return _http.post('/api/audio-visual/edition-job-control/cancel', payload)
  }
}